import HeroImage from '@/components/HeroImage';
import type { FC } from 'react';
import type { LayoutProps } from './types';
import { Box } from '@chakra-ui/react';
import useResponsive from 'hooks/useResponsive';
import ButtonBack from '@/components/ButtonBack';
import { GetPageLink } from '@/utility/getLinkPage';
import { useRouter } from 'next/router';
import BottomCardInfo from '@/components/BottomCardInfo';
import { LogoIdnConnect } from '@/components/Logo/IdnConnect';

const Layout: FC<LayoutProps> = ({
  children,
  backUrl,
  backUrlonClick,
  withLogo = true,
}) => {
  const { isMobile } = useResponsive();
  const router = useRouter();

  return (
    <>
      <Box backgroundColor="#F6F7F9" height="100%" minHeight="100vh" maxHeight="100vh" width="100%" display={isMobile ? 'block' : 'flex'} data-testid="mainLayout">
        <HeroImage />
        <Box data-testid="mainLayout_container" overflow="auto" backgroundColor="#F6F7F9" display="flex" flexWrap="wrap" alignItems="center" justifyContent="center" width="100%" padding={isMobile ? '16px 24px 21px' : '28px 24px'} borderRadius={isMobile ? '24px 24px 0 0' : '0'} marginTop={isMobile ? '-24px' : '0'} maxWidth={isMobile ? '100%' : '45%'}>
          <Box width="100%" maxWidth={isMobile ? '100%' : '390px'}>
            {backUrl && (
              <ButtonBack
                data-testid="buttonBack"
                url={GetPageLink(backUrl, router.query)}
                onClick={backUrlonClick || undefined}
              />
            )}
            <Box>
              <Box data-testid="mainLayout_content">
                {withLogo && <LogoIdnConnect />}
                {children}
              </Box>
              <Box>
                <BottomCardInfo />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
